import { render } from "./ImgToNameAndProfession.vue?vue&type=template&id=276ede56&scoped=true"
import script from "./ImgToNameAndProfession.vue?vue&type=script&lang=js"
export * from "./ImgToNameAndProfession.vue?vue&type=script&lang=js"

import "./ImgToNameAndProfession.vue?vue&type=style&index=0&id=276ede56&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276ede56"]])

export default __exports__